<h1 mat-dialog-title>{{ isEdit ? 'Freigabe bearbeiten' : 'Freigabe erteilen' }}</h1>
<div mat-dialog-content>
    <ng-container *ngIf="isEdit; else createStepper">
        <p class="edit-summary">
            {{ editFreigabe?.betrieb_freigeber }}
            <span *ngIf="editFreigabe?.zusatz_freigeber"> – {{ editFreigabe.zusatz_freigeber }}</span>
            →
            {{ editFreigabe?.betrieb_freigabe }}
            <span *ngIf="editFreigabe?.zusatz_freigabe"> – {{ editFreigabe.zusatz_freigabe }}</span>
        </p>
        <ng-container *ngTemplateOutlet="rechte"></ng-container>
    </ng-container>
    <ng-template #createStepper>
        <mat-stepper orientation="vertical">
            <mat-step>
                <ng-template matStepLabel>Freizugebener Betrieb</ng-template>
                <kiene-autocomplete
                    [placeholder]="'Freizugebener Betrieb:'"
                    [genericApiUrl]="apiBaseUrl + 'kunde/search.php'"
                    [params]="sourceClientParams"
                    [displayFields]="betriebDisplayFields"
                    [separator]="' | '"
                    [focus]="false"
                    [openOnlyOnClick]="true"
                    (elementSelected)="setClient($event)"
                    [showClear]="true"
                ></kiene-autocomplete>
                <div class="one-row">
                    <button mat-button matStepperNext>Weiter</button>
                </div>
            </mat-step>
            <mat-step>
                <ng-template matStepLabel>Empf&auml;nger VVVO</ng-template>
                <kiene-autocomplete
                    [placeholder]="'Empf&auml;nger Betrieb:'"
                    [genericApiUrl]="apiBaseUrl + 'kunde/search.php'"
                    [params]="recipientParams"
                    [displayFields]="betriebDisplayFields"
                    [separator]="' | '"
                    [focus]="false"
                    [openOnlyOnClick]="true"
                    (elementSelected)="setRecipient($event)"
                    [showClear]="true"
                ></kiene-autocomplete>

                <mat-form-field>
                    <mat-label>VVVO</mat-label>
                    <input matInput type="text" [formControl]="vvvoCtrl" minlength="12" maxlength="15" />
                    <span matSuffix>({{ vvvoCtrl.value?.length || 0 }}/15)</span>
                </mat-form-field>
                <div class="one-row step-actions-inline">
                    <button mat-button matStepperNext>Weiter</button>
                    <button mat-button matStepperPrevious>Zur&uuml;ck</button>
                </div>
            </mat-step>
            <mat-step>
                <ng-template matStepLabel>Rechte</ng-template>
                <ng-container *ngTemplateOutlet="rechte"></ng-container>
                <div class="one-row step-actions-inline">
                    <button mat-button matStepperPrevious>Zur&uuml;ck</button>
                </div>
            </mat-step>
            <mat-step>
                <ng-template matStepLabel>Freigabe erteilen</ng-template>
                <button mat-flat-button color="accent" (click)="speichern()" [disabled]="!vvvoCtrl.valid || !kunde">
                    Freigabe erteilen
                </button>
                <div class="one-row">
                    <button mat-button matStepperPrevious>Zur&uuml;ck</button>
                    <span class="spacer"></span>
                </div>
            </mat-step>
        </mat-stepper>
    </ng-template>
</div>
<div mat-dialog-actions align="end">
    <button mat-button (click)="dialogRef.close(false)">Abbrechen</button>
    <button *ngIf="isEdit" mat-flat-button color="accent" (click)="speichern()">Speichern</button>
</div>

<ng-template #rechte>
    <div class="rechte-block">
        <div class="one-row step-actions-inline">
            <button mat-stroked-button type="button" (click)="allesAn()">Alles</button>
        </div>
        <mat-checkbox [(ngModel)]="modulBelege">Belege und Bestandsb&uuml;cher</mat-checkbox>
        <mat-checkbox [(ngModel)]="modulTierbewegung">Tierbewegungen</mat-checkbox>
        <mat-checkbox [(ngModel)]="modulBio">Biologische / betriebswirtschaftliche Daten</mat-checkbox>
    </div>
</ng-template>
